<template>
  <el-dialog
    v-if="DialogVisible"
    :visible.sync="DialogVisible"
    width="1000px"
    class="large-padding-dialog"
    :close-on-click-modal="false"
    :before-close="Hide"
  >
    <span slot="title" class="el-dialog__title">
      {{ Type == "Create" ? l("发布") : l("管理")
      }}<template v-if="DialogFormData.quality_type == 1">{{
        l("原料求购")
      }}</template
      >
      <template v-else-if="DialogFormData.quality_type == 2">{{
        l("零切求购")
      }}</template>
      <template v-else-if="DialogFormData.quality_type == 3">{{
        l("锻件定制")
      }}</template
      ><template v-else-if="DialogFormData.quality_type == 4">{{
        l("机加工")
      }}</template>
    </span>
    <el-form
      :model="DialogFormData"
      ref="DialogFormData"
      :rules="dialogRules"
      :class="[{ View: Type == 'View' }]"
      label-position="top"
    >
      <AlertTip
        v-if="DialogFormData.status == 0"
        :title="l('审核中，请耐心等待')"
      />
      <AlertTip
        v-if="DialogFormData.status == -1"
        type="danger"
        :title="l('已下架') + '：'"
        :description="DialogFormData.invalid_reason"
      />

      <div class="FormSubTitle">{{ l("基本信息") }}</div>

      <el-row :gutter="20">
        <el-col
          v-if="
            DialogFormData.quality_type == 2 || DialogFormData.quality_type == 3 || DialogFormData.quality_type == 4
          "
          key="title"
          :span="12"
        >
          <el-form-item :label="l('标题')" prop="title">
            <el-input
              v-model="DialogFormData.title"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col
          v-if="DialogFormData.quality_type == 1"
          key="category_id"
          :span="12"
        >
          <el-form-item :label="l('品类')" prop="category_id">
            <el-select
              v-model="DialogFormData.category_id"
              :disabled="Type != 'Create'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.categoryList_purchase"
                :key="item.id"
                :label="l(item.name)"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
          v-if="DialogFormData.quality_type == 1"
          key="child_category"
          :span="12"
        >
          <el-form-item
            :label="l('品名')"
            prop="child_category"
            style="position: relative"
          >
            <span slot="label">
              <span>{{ l("品名") }}</span>
              <span v-show="Type == 'Create'" class="label_tip">
                <span
                  v-show="select_child_category"
                  @click="
                    select_child_category = false;
                    $nextTick(() => $refs.child_category_input.focus());
                  "
                  >{{ l("点击输入自定义品名") }}</span
                >
                <span
                  v-show="!select_child_category"
                  @click="select_child_category = true"
                  >{{ l("点击使用系统预设品名") }}</span
                >
              </span>
            </span>
            <el-select
              v-if="select_child_category"
              key="child_category_select"
              v-model="DialogFormData.child_category"
              :disabled="Type != 'Create'"
              :no-data-text="l('请先选择品类')"
            >
              <el-option
                v-for="item in child_categoryList"
                :key="item"
                :label="l(item)"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="child_category_input"
              ref="child_category_input"
              v-model="DialogFormData.child_category"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type != 'Create'"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col
          key="material"
          :span="12"
        >
          <el-form-item
            :label="l('材料')"
            prop="material"
            style="position: relative"
          >
            <span slot="label">
              <span>{{ l("材料") }}</span>
              <span v-show="Type == 'Create'" class="label_tip">
                <span
                  v-show="select_material"
                  @click="
                    select_material = false;
                    $nextTick(() => $refs.material_input.focus());
                  "
                  >{{ l("点击输入自定义材料") }}</span
                >
                <span
                  v-show="!select_material"
                  @click="select_material = true"
                  >{{ l("点击使用系统预设材料") }}</span
                >
              </span>
            </span>
            <el-select
              v-if="select_material"
              key="material_select"
              v-model="DialogFormData.material"
            >
              <el-option
                v-for="item in $store.state.basicInfo.materialList"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>

            <el-input
              v-else
              key="material_input"
              ref="material_input"
              v-model="DialogFormData.material"
              :placeholder="l('请输入') + l('内容')"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col
          v-if="
            DialogFormData.quality_type == 1 || DialogFormData.quality_type == 2
          "
          key="specification"
          :span="12"
        >
          <el-form-item :label="l('规格')" prop="specification">
            <el-input
              v-model="DialogFormData.specification"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col v-if="DialogFormData.quality_type == 3" :span="12">
          <el-form-item :label="l('类型')" prop="forge_type">
            <el-select
              v-model="DialogFormData.forge_type"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.forge_typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col v-if="DialogFormData.quality_type == 4" :span="12">
          <el-form-item :label="l('类型')" prop="machining_type">
            <el-select
              v-model="DialogFormData.machining_type"
              :disabled="Type == 'View'"
            >
              <el-option
                v-for="item in $store.state.basicInfo.machining_typeList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item :label="l('数量')" prop="amount">
            <el-row>
              <el-col :span="16">
                <el-input
                  v-model="DialogFormData.amount"
                  :placeholder="l('数量')"
                  :disabled="Type == 'View'"
                ></el-input>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="DialogFormData.unit"
                  :disabled="Type == 'View'"
                >
                  <el-option
                    v-for="item in $store.state.basicInfo.unitList"
                    :key="item"
                    :label="l(item)"
                    :value="item"
                  ></el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form-item>
        </el-col>

        <el-col
          v-if="
            DialogFormData.quality_type == 1 || DialogFormData.quality_type == 2
          "
          :span="12"
        >
          <el-form-item :label="l('钢厂')">
            <el-input
              v-model="DialogFormData.steel_mill"
              :placeholder="l('请输入') + l('内容')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <template v-if="DialogFormData.quality_type == 3">
          <el-col :span="12">
            <el-form-item :label="l('交货状态')" prop="extra_deliver_status">
              <el-input
                v-model="DialogFormData.extra_deliver_status"
                :placeholder="l('毛坯、粗加工、精加工等')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="l('探伤')" prop="extra_flaw_detect">
              <el-input
                v-model="DialogFormData.extra_flaw_detect"
                :placeholder="l('请输入') + l('内容')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="l('热处理')" prop="extra_heat_treatment">
              <el-input
                v-model="DialogFormData.extra_heat_treatment"
                :placeholder="l('正火、退火、调质等')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="l('光洁度')" prop="extra_surface_grade">
              <el-input
                v-model="DialogFormData.extra_surface_grade"
                :placeholder="l('请输入') + l('内容')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="l('硬度')" prop="extra_hard">
              <el-input
                v-model="DialogFormData.extra_hard"
                :placeholder="l('请输入') + l('内容')"
                :disabled="Type == 'View'"
              ></el-input>
            </el-form-item>
          </el-col>
        </template>

        <el-col :span="12" v-if="DialogFormData.quality_type == 4">
          <el-form-item :label="l('交货状态')" prop="extra_deliver_status">
            <el-input
              v-model="DialogFormData.extra_deliver_status"
              :placeholder="l('按图纸要求交付')"
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <ResourceListUpLoad
            :label="l('图片说明（可上传设计图纸、成品照片等）')"
            prop="img_array"
            usage="purchase"
            :initResourceUrl.sync="DialogFormData.img_array"
            :disabled="Type == 'View'"
          />
        </el-col>
        <el-col v-if="DialogFormData.quality_type==3||DialogFormData.quality_type==4" :span="6">
          <ResourceUpLoad
            :label="l('PDF附件')"
            prop="pdf"
            file_type="pdf"
            usage="purchase"
            :initResourceUrl.sync="DialogFormData.pdf"
            :disabled="Type == 'View'"
          />
        </el-col>
      </el-row>

      <div class="FormSubTitle">{{ l("其他要求") }}</div>

      <el-row :gutter="20">
        <el-col 
           v-if="DialogFormData.quality_type == 1 || DialogFormData.quality_type == 2 || DialogFormData.quality_type == 3"
          :span="8" 
        >
          <el-form-item :label="l('计重方式')" prop="weight_method">
            <el-radio
              v-for="item in $store.state.basicInfo.weight_methodList"
              :key="item.id"
              v-model="DialogFormData.weight_method"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col
          v-if="
            DialogFormData.quality_type == 1 || DialogFormData.quality_type == 2
          "
          :span="8"
        >
          <el-form-item :label="l('需要质保书')" prop="have_warranty">
            <el-radio
              v-for="item in $store.state.basicInfo.have_warrantyList"
              :key="item.id"
              v-model="DialogFormData.have_warranty"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col v-if="DialogFormData.quality_type == 3 || DialogFormData.quality_type == 4" :span="8">
          <el-form-item :label="l('要求出具报告')" prop="have_report">
            <el-radio
              v-for="item in $store.state.basicInfo.have_reportList"
              :key="item.id"
              v-model="DialogFormData.have_report"
              :label="item.id"
              :disabled="Type == 'View'"
              >{{ item.name }}</el-radio
            >
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item :label="l('截止日期')" prop="expire_time">
            <el-date-picker
              v-model="DialogFormData.expire_time"
              type="date"
              :placeholder="l('选择日期')"
              value-format="yyyy-MM-dd HH:mm"
              :picker-options="pickerOptions"
              :clearable="false"
              :disabled="Type == 'View'"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>

        
        <el-col :span="24">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item :label="l('国家/地区')" prop="country">
                <el-select v-model="DialogFormData.country" :placeholder="l('请选择')" :disabled="Type == 'View'" @change="DialogFormData.address=['','']" filterable>
                  <el-option v-for="item in $store.state.basicInfo.countryList" :key="item.code" :label="item.cnName+' ('+item.name+')'"
                    :value="item.code">
                    <span style="float: left">{{item.cnName}}（{{ item.name }}）</span>
                    <span style="float: right">
                      <img :src="GetResourceUrl('flags/' + item.code.toLowerCase() + '.png')" style="width:30px;" />
                    </span>
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item :label="l('城市')" prop="address">
                <el-cascader v-if="DialogFormData.country=='CN'"
                  v-model="DialogFormData.address"
                  :options="$store.state.basicInfo.cityList"
                  :props="{
                    expandTrigger: 'hover',
                    label: 'name',
                    value: 'name',
                    children: 'child',
                    emitPath: true,
                  }"
                  clearable
                  :disabled="Type == 'View'"
                ></el-cascader>

                <el-input v-else
                  v-model="DialogFormData.address[0]"
                  :placeholder="l('请输入内容')"
                  :disabled="Type == 'View'"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>


        <el-col :span="24">
          <el-form-item :label="l('补充说明')" prop="description">
            <el-input
              type="textarea"
              :rows="5"
              v-model="DialogFormData.description"
              :placeholder="
                l('您可以填写更多补充说明，如心理价位、包装要求、用途等')
              "
              :disabled="Type == 'View'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="Hide">{{ l("取 消") }}</el-button>
      <el-button
        v-if="
          Type == 'View' &&
          $store.getters.checkPermission('buyer_purchase.edit') &&
          DialogFormData.create_user_id == $store.state.session.user.id
        "
        type="warning"
        @click="Type = 'Edit'"
        >{{ l("修 改") }}</el-button
      >
      <el-button
        v-if="Type == 'Create' || Type == 'Edit'"
        type="primary"
        @click="submitForm"
        >{{ l("保 存") }}</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import dialogMixin from "@/assets/js/dialogMixin";

export default {
  name: "CreateOrEditBuyerPurchase",
  components: {},
  mixins: [dialogMixin],
  data() {
    return {
      DialogFormData: {
        code: null,
        status: null,

        title: "",
        quality_type: null,
        forge_type: null,
        machining_type: null,
        character: 1,
        category_id: null,
        child_category: null,
        material: "",
        specification: "", //来自specification_amount:"",
        amount: "", //来自specification_amount:"",
        unit: "", //来自specification_amount:"",
        weight_method: 1,
        have_warranty: 1,
        have_report: 1,
        steel_mill: "",
        address: "",
        country: "CN",
        img_array: [], //来自img_array:""
        pdf: "",
        description: "",
        expire_time: "",
        extra_deliver_status: "", //来自extra_params
        extra_technique: "", //来自extra_params
        extra_flaw_detect: "", //来自extra_params
        extra_heat_treatment: "", //来自extra_params
        extra_surface_grade: "", //来自extra_params
        extra_hard: "", //来自extra_params
      },
      dialogRules: {
        title: [
          {
            required: true,
            message: this.l("请输入") + this.l("名称"),
            trigger: "change",
          },
        ],
        forge_type: [
          {
            required: true,
            message: this.l("请选择") + this.l("类型"),
            trigger: "change",
          },
        ],
        machining_type: [
          {
            required: true,
            message: this.l("请选择") + this.l("类型"),
            trigger: "change",
          },
        ],
        category_id: [
          {
            required: true,
            type: "number",
            message: this.l("请选择") + this.l("品类"),
            trigger: "change",
          },
        ],
        child_category: [
          {
            required: true,
            message: this.l("请输入") + this.l("品名"),
            trigger: "change",
          },
        ],
        material: [
          {
            required: true,
            message: this.l("请输入") + this.l("材料"),
            trigger: "change",
          },
        ],
        specification: [
          {
            required: true,
            message: this.l("请输入") + this.l("规格"),
            trigger: "change",
          },
        ],
        amount: [
          {
            required: true,
            message: this.l("请输入") + this.l("数量"),
            trigger: "change",
          },
        ],
        address: [
          {
            required: true,
            message: this.l("请选择") + this.l("城市"),
            trigger: "change",
          },
          {
            validator: (rule, value, callback) => {
              if (!value[0]) {
                callback(new Error(this.l("请选择") + this.l("城市")));
              } else {
                callback();
              }
            },
          },
        ],
        country: [
          { required: true, message: this.l("请选择") + this.l("国家/地区"), trigger: "change" },
        ],
      },
      pickerOptions: {
        // disabledDate(time) {
        //   return (
        //     time.getTime() < Date.now() ||
        //     time.getTime() > Date.now() + 3600 * 1000 * 24 * 30
        //   );
        // },
        shortcuts: [
          {
            text: this.l("1天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 1);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.l("3天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 3);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.l("7天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
          {
            text: this.l("30天后"),
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
              picker.$emit("pick", date);
            },
          },
        ],
      },

      select_child_category: true,
      select_material: true,
    };
  },
  computed: {
    child_categoryList() {
      var category = this.$store.state.basicInfo.categoryList.find(
        (item) => item.id == this.DialogFormData.category_id
      );
      if (category) {
        return category.child.map((item) => item.name);
      } else {
        return [];
      }
    },
  },
  watch: {},
  methods: {
    BeforeShow() {
      return new Promise((resolve, reject) => {
        if (this.Type == "Create") {
          //先检查还有没有发布资格
          this.axios
            .get(`/api/buyer_purchase/check_user_chance/`)
            .then(() => {
              if (
                this.DialogFormData.quality_type == 1 ||
                this.DialogFormData.quality_type == 2
              ) {
                this.DialogFormData.unit = this.l("吨");
              } else if (this.DialogFormData.quality_type == 3) {
                this.DialogFormData.unit = this.l("件");
                this.DialogFormData.specification = this.l("如图");
              }
              var date = new Date(); //默认为7天后
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              this.DialogFormData.expire_time =
                this.$utils.formatDate(date) + " 00:00";
              resolve();
            })
            .catch(() => {
              this.Hide();
              reject();
            });
        } else if (this.Type == "View") {
          this.axios
            .get(`/api/buyer_purchase/${this.DialogFormData.code}/`)
            .then((response) => {
              response.img_array = JSON.parse(response.img_array);
              response.address = response.country=="CN"?response.address.split("/"):[response.address];
              response.specification =
                response.specification_amount[0].specification;
              response.amount = response.specification_amount[0].amount;
              response.unit = response.specification_amount[0].unit;

              response.extra_deliver_status =
                response.extra_params.extra_deliver_status;
              response.extra_technique = response.extra_params.extra_technique;
              response.extra_flaw_detect =
                response.extra_params.extra_flaw_detect;
              response.extra_heat_treatment =
                response.extra_params.extra_heat_treatment;
              response.extra_surface_grade =
                response.extra_params.extra_surface_grade;
              response.extra_hard = response.extra_params.extra_hard;

              this.DialogFormData = response;
              resolve();
            })
            .catch(() => {
              reject();
            });
        }
      });
    },
    AfterShow() {},
    submitForm() {
      this.$refs["DialogFormData"].validate((valid, obj) => {
        if (!valid) {
          return this.$message.error(obj[Object.keys(obj)[0]][0].message);
        }

        if (this.DialogFormData.quality_type == 3||this.DialogFormData.quality_type == 4) {
          if(!this.DialogFormData.img_array[0] && !this.DialogFormData.pdf){
            return this.$message.error("请至少上传一张图片或PDF");
          }
        }

        var img_array = JSON.stringify(this.DialogFormData.img_array);
        var specification_amount = [
          {
            specification: this.DialogFormData.specification,
            amount: this.DialogFormData.amount,
            unit: this.DialogFormData.unit,
          },
        ];
        var address = this.DialogFormData.country=="CN"?this.DialogFormData.address.join("/"):this.DialogFormData.address[0];
        var extra_params = {
          extra_deliver_status: this.DialogFormData.extra_deliver_status,
          extra_technique: this.DialogFormData.extra_technique,
          extra_flaw_detect: this.DialogFormData.extra_flaw_detect,
          extra_heat_treatment: this.DialogFormData.extra_heat_treatment,
          extra_surface_grade: this.DialogFormData.extra_surface_grade,
          extra_hard: this.DialogFormData.extra_hard,
        };

        if (this.Type == "Create") {
          this.axios
            .post(
              `/api/buyer_purchase/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                specification_amount,
                address,
                extra_params,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        } else {
          this.axios
            .put(
              `/api/buyer_purchase/${this.DialogFormData.code}/`,
              Object.assign({}, this.DialogFormData, {
                img_array,
                specification_amount,
                address,
                extra_params,
              })
            )
            .then((data) => {
              this.$emit("submitDialog");
              this.Hide();
            });
        }
      });
    },
  },
};
</script>


<style scoped lang="scss">
/deep/.el-form--label-top .el-form-item__label {
  padding-bottom: 0;
}

.label_tip {
  color: $warningColor;
  position: absolute;
  right: 0;
  text-decoration: underline;
  cursor: pointer;
  font-size: 12px;
  top: 2px;
}
</style>

